import addUserModifiedAttribute from './add-user-modified-attribute';

export default {
  addUserModifiedAttribute,
};
